import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../Resignation/resignationflow.css"

import { DatePicker, Input, Card, Form, Select, Row, Col, Modal } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { Button, message, Upload } from "antd";
import moment from "moment";
import Service from "../../service";
import { hideAuthLoader, showAuthLoader } from "../../appRedux/actions";
const { Option } = Select;

function ResignationFlow({ isVisible, onClose, onSuccess }) {
  const dispatch = useDispatch();
  let { authUser } = useSelector(({ auth }) => auth);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [selectedDate, setSelectedDate] = useState(moment().startOf('day'));
  const [empdropdown, setEmpDropdown] = useState([]);
  const [holiday, setholiday] = useState([]);
  const [branch, setBranch] = useState("");

  const onChange = (date, dateString) => {
    setSelectedDate(date);
  };

  const [selDate, setSelDate] = useState(null);

  const OnChangeForRequest = (date, dateString) => {
    setSelDate(dateString);
  };

  useEffect(() => {
    if (selectedDate) {
      calculateLastDate(selectedDate);
    }
  }, [selectedDate, holiday]);

  useEffect(() => {
    holidayList();
  }, [])

  useEffect(() => {
    getEmpdropdown();
  }, [branch])

  const [lastDate, setLastDate] = useState(null);

  const holidayList = async () => {
    try {
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.getholidays,
      });
      if (response.data && response.data.data && response.data.status === 200) {
        const holidays = response.data.data.map(item => item.holiday_date.slice(0, 10));
        setholiday(holidays);
      } else {
        message.error(response.data.message);
      }
    }
    catch (error) {
      console.log(error);
    }
  }

  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();

      formData.append(
        "last_date",
        moment(values?.request_last_date).format("YYYY-MM-DD")
      );
      formData.append("reason", values?.reason);
      formData.append("comments", values?.comments);
      formData.append("employee_code", String(values?.employee_code));
      fileList.forEach((file) => {
        formData.append("attachment", file.originFileObj);
      });

      dispatch(showAuthLoader());
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.separationByAdminForUser,
        body: formData,
      });
      dispatch(hideAuthLoader());
      if (response.data && response.data.data && response.data.status === 200) {
        message.success(response.data.message);
        form.resetFields();
        setLastDate(null);
        setFileList([]);
        onClose(); // Close modal on success
        if (onSuccess) {
          onSuccess(); // Call parent success handler if provided
        }
      } else {
        form.resetFields();
        message.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const calculateLastDate = (date) => {
    const today = moment(date);
    const noticePeriod = 60;
    console.log(holiday, "holidayyysss")
    const lastDate = moment(today).add(noticePeriod, 'days');
    while (lastDate.day() === 6 || lastDate.day() === 0 || holiday.includes(lastDate.format('YYYY-MM-DD'))) {
      if (lastDate.day() === 6) { // Saturday
        lastDate.subtract(1, 'days'); // Move back one day to Friday
      } else if (lastDate.day() === 0) { // Sunday
        lastDate.subtract(2, 'days'); // Move back two days to Friday
      } else { // Holiday
        lastDate.subtract(1, 'days'); // Move back one day
      }
    }

    setLastDate(lastDate.format('YYYY-MM-DD'));
  };

  const disabledDate = (currentDate) => {
    const presentDate = moment().startOf("day");
    return currentDate && !currentDate.isSame(presentDate, "day");
  };

  const textStyle = {
    margin: "10px 0px",
    width: "70%",
    resize: "none",
    marginLeft: "80px",
  };

  const handleFileChange = (info) => {
    console.log("🚀 ~ handleFileChange ~ info:", info);
    let fileList = [...info.fileList];
    setFileList(fileList);
  };

  const disabledDateRequested = current => {
    return moment(current).startOf('day') <= moment().startOf('day').subtract(1, 'day');
  };

  const getEmpdropdown = async () => {
    try {
      const reqBody = {
        branch: branch ? branch : "none",
      };
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.empDropdownList,
        body: reqBody,
      });
      if (response.data && response.data.data) {
        const emp = response.data.data;
        setEmpDropdown(emp);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setLastDate(null);
    setFileList([]);
    onClose();
  };

  return (
  
<Modal
  title="Add Resignation"
  open={isVisible}
  onCancel={handleCancel}
  footer={[
    <Button
      key="cancel"
      type="default"
      className="delete-btn"
      onClick={handleCancel}
      style={{ marginRight: "10px" }}
    >
      Cancel
    </Button>,
    <Button
      key="submit"
      type="primary"
      onClick={() => form.submit()}
    >
      Submit
    </Button>,
  ]}
  width={800}
  destroyOnClose={true}
>
  <Form
    className="form-control-group admin-user-resignation"
    onFinish={handleSubmit}
    form={form}
  >
    <div className="main-form-wrapper">
      <div className="form-container">
        {/* Row 1: Date of Resignation & Last Date */}
        <div className="form-row">
          <div className="form-col">
            <div className="form-item">
              <Form.Item
                label="Date of Resignation"
                name="date_of_resignation"
                className="search-row"
                rules={[
                  {
                    required: true,
                    message: "Please select date!",
                  },
                ]}
                initialValue={moment().startOf("day")}
              >
                <p>{moment().startOf("day").format("YYYY-MM-DD")}</p>
              </Form.Item>
            </div>
          </div>

          <div className="form-col">
            <div className="form-item">
              <Form.Item
                label="Last Date"
                name="request_last_date"
                className="search-row"
                rules={[
                  {
                    required: true,
                    message: "Please select last date!",
                  },
                ]}
              >
                <DatePicker
                  disabledDate={disabledDateRequested}
                  onChange={OnChangeForRequest}
                  className="fulldate-width"
                />
              </Form.Item>
            </div>
          </div>
        </div>

        {/* Row 2: Employee Code & Employee */}
        <div className="form-row">
          <div className="form-col">
            <div className="form-item">
              <Form.Item
                label="Employee Code"
                name="employee_code"
                className="search-row"
                rules={[
                  {
                    required: true,
                    message: "Please select employee code!",
                  },
                ]}
              >
                <Select
                  size="middle"
                  showSearch
                  className="fulldate-width"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  onChange={(e) => {
                    let data = empdropdown.filter(
                      (val) => val.emp_code == e
                    );
                    form.setFieldsValue({
                      employee: data[0]?._id,
                    });
                  }}
                >
                  {empdropdown.map((item, index) => (
                    <Option
                      key={index}
                      value={item?.emp_code}
                      style={{ textTransform: "capitalize" }}
                    >
                      {item?.emp_code}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </div>

          <div className="form-col">
            <div className="form-item">
              <Form.Item
                label="Employee"
                name="employee"
                className="search-row"
                rules={[
                  {
                    required: true,
                    message: "Please select employee!",
                  },
                ]}
              >
                <Select
                  size="large"
                  showSearch
                  className="fulldate-width"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  onChange={(e) => {
                    let data = empdropdown.filter((val) => val._id == e);
                    form.setFieldsValue({
                      employee_code: data[0]?.emp_code,
                    });
                  }}
                >
                  {empdropdown.map((item, index) => (
                    <Option
                      key={index}
                      value={item?._id}
                      style={{ textTransform: "capitalize" }}
                    >
                      {item?.first_name + " " + item?.last_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </div>
        </div>

        {/* Row 3: Reason For Resignation */}
        <div className="form-row">
          <div className="form-col-full">
            <div className="form-item">
              <Form.Item
                label="Reason For Resignation"
                name="reason"
                className="search-row"
                rules={[
                  {
                    required: true,
                    message: "Please select reason!",
                  },
                ]}
              >
                <Select
                  showSearch
                  className="fulldate-width"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={[
                    { value: "Health issue", label: "Health issue" },
                    { value: "Career Changes", label: "Career Changes" },
                    { value: "Travelling", label: "Travelling" },
                    { value: "Abroad", label: "Abroad" },
                    { value: "Higher studies", label: "Higher studies" },
                    { value: "Work related issue", label: "Work related issue" },
                    { value: "Marriage", label: "Marriage" },
                    { value: "Performance issue", label: "Performance issue" },
                    { value: "Ask to Leave", label: "Ask to Leave" },
                    {
                      value: "Better Role & Career progression",
                      label: "Better Role & Career progression",
                    },
                    {
                      value: "Code of Conduct Discipline",
                      label: "Code of Conduct Discipline",
                    },
                    {
                      value: "Dissatisfaction with manager",
                      label: "Dissatisfaction with manager",
                    },
                    {
                      value: "Entrepreneur, New business",
                      label: "Entrepreneur, New business",
                    },
                    {
                      value: "Family Issues & Commitments",
                      label: "Family Issues & Commitments",
                    },
                    {
                      value: "Mis fit for role in Elsner",
                      label: "Mis fit for role in Elsner",
                    },
                    {
                      value: "Relocating to Another City",
                      label: "Relocating to Another City",
                    },
                    { value: "Salary Growth", label: "Salary Growth" },
                  ]}
                />
              </Form.Item>
            </div>
          </div>
        </div>

        {/* Row 4: Comments */}
        <div className="form-row">
          <div className="form-col-full">
            <div className="form-item">
              <Form.Item
                label="Comments"
                name="comments"
                className="search-row"
                rules={[
                  {
                    required: true,
                    message: "Please enter comments!",
                  },
                ]}
              >
                <Input.TextArea
                  autoSize={{
                    minRows: 5,
                    maxRows: 5,
                  }}
                  style={textStyle}
                />
              </Form.Item>
            </div>
          </div>
        </div>

        {/* Row 5: Any Attachments */}
        <div className="form-row">
          <div className="form-col-full">
            <div className="form-item">
              <Form.Item
                label="Any Attachments"
                name="attachments"
                className="search-row"
              >
                <Upload
                  multiple={false}
                  beforeUpload={() => false}
                  onChange={handleFileChange}
                >
                  <Button icon={<UploadOutlined />}>Click to Upload</Button>
                </Upload>
              </Form.Item>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Form>
</Modal>

  );
}

export default ResignationFlow;